import { useParams } from 'next/navigation';
import { getLocalizationInfo } from 'project.config';

const useI18n = () => {
  const { locale } = useParams();

  const { country } = getLocalizationInfo(locale);

  return { country: country.countryCode, currency: country.currency, currencySymbol: country.currencyCode };
};

export default useI18n;
